<div class="d-flex">
	<div
		class="align-self-center vw-5 text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
		(click)="previousWeek()"
	>
		<i class="bi bi-chevron-left fs-4" aria-hidden="true"></i>
	</div>
	<div
		class="vw-30 text-center mt-2 hand-cursor date-nav-btn rounded-pill theme-main-border-color"
		(click)="resetDateClick()"
	>
		<span class="theme-main-color"
			>Semaine {{ weekNumber.value + ' : ' }}
		</span>
		<span
			*ngIf="dateRange.value[0].getMonth() === dateRange.value[1].getMonth()"
			class="fw-bold"
			>{{
				dateRange.value[0].getDate() +
					'-' +
					dateRange.value[1].getDate() +
					' ' +
					monthsFr[dateRange.value[0].getMonth()] +
					' ' +
					yearNumber.value
			}}
		</span>
		<span
			*ngIf="dateRange.value[0].getMonth() !== dateRange.value[1].getMonth()"
			class="fw-bold"
			>{{
				dateRange.value[0].getDate() +
					' ' +
					monthsFr[dateRange.value[0].getMonth()] +
					' - ' +
					dateRange.value[1].getDate() +
					' ' +
					monthsFr[dateRange.value[1].getMonth()] +
					' ' +
					yearNumber.value
			}}
		</span>
	</div>
	<div
		class="align-self-center vw-5 text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
		(click)="nextWeek()"
	>
		<i class="bi bi-chevron-right fs-4 vw-5" aria-hidden="true"></i>
	</div>
</div>
